import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormText,
} from "reactstrap";

function SupportUserResetPasswordModal({ isOpen, toggle, onSubmit, user }) {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const validatePassword = (password, confirmPassword) => {
        const errors = {};
        if (!password || password.length < 6) {
            errors.password = "Password must be at least 6 characters.";
        }
        if (!confirmPassword) {
            errors.confirmPassword = "Please confirm your password.";
        } else if (password !== confirmPassword) {
            errors.confirmPassword = "Passwords do not match.";
        }
        return errors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        const validationErrors = validatePassword(password, confirmPassword);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            onSubmit(password);
            setPassword("");
            setConfirmPassword("");
            setSubmitted(false);
            setErrors({});
            toggle();
        }
    };

    const handleClose = () => {
        setPassword("");
        setConfirmPassword("");
        setErrors({});
        setSubmitted(false);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>Reset {user ? user?.fname + " " + user?.lname : " Support User"} Password</ModalHeader>
            <ModalBody style={{ backgroundColor: "#fff" }}>
                <form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="newPassword">New Password</Label>
                        <div style={{ position: "relative" }}>
                            <Input
                                type={showPassword ? "text" : "password"}
                                id="newPassword"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter new password"
                                className="form-control input-date-filter remove-bottom-margin"
                            />
                            <i
                                className={`mdi ${showPassword ? "mdi-eye-off" : "mdi-eye"}`}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#666",
                                }}
                            />
                        </div>
                        {submitted && errors.confirmPassword && (
                            <div style={{ color: '#ff0000', fontSize: '0.875rem' }}>
                                {errors.password}
                            </div>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <Label for="confirmPassword">Confirm Password</Label>
                        <div style={{ position: "relative" }}>
                            <Input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirm new password"
                                className="form-control input-date-filter remove-bottom-margin"
                            />
                            <i
                                className={`mdi ${showConfirmPassword ? "mdi-eye-off" : "mdi-eye"}`}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#666",
                                }}
                            />
                        </div>
                        {submitted && errors.confirmPassword && (
                            <div style={{ color: '#ff0000', fontSize: '0.875rem' }}>
                                {errors.confirmPassword}
                            </div>
                        )}
                    </FormGroup>
                    <button type="submit" className="btn btn-block btn-info"
                        style={{
                            borderRadius: "8px",
                            fontWeight: 500,
                            fontSize: "16px",
                            padding: "10px 18px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                            whiteSpace: "nowrap",
                        }}>
                        <i className="mdi mdi-lock-reset" style={{ fontSize: "15px", color: 'white' }}></i> Reset Password
                    </button>
                </form>
            </ModalBody>
        </Modal>
    );
}

export default SupportUserResetPasswordModal;
